import PropTypes from 'prop-types';

import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Carousel, Text, UserCard} from '@/src/ui';

import css from '../styles/MultipleSearchUsers.module.css';

const MultipleSearchUsers = ({onShowClick, data, currentUserId, isClinic}) => {
  return (
    <div className={css.widget}>
      <div className={css.heading}>
        <Text
          color={Text.COLOR.PRIMARY}
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
          fontFamily={Text.FONT_FAMILY.RUBIK}
        >
          <TextLocal id={isClinic ? 'search.clinics' : 'search.users'} />
        </Text>
      </div>
      {Boolean(data) && (
        <div className={css.usersList}>
          <Carousel
            settings={{
              loop: false,
            }}
            navigationPosition={Carousel.NAVIGATION_POSITION.BOTTOM}
          >
            {data.map((user) => (
              <div className={css.userCard} key={user.id}>
                <UserCard {...user} currentUserId={currentUserId} />
              </div>
            ))}
          </Carousel>
        </div>
      )}
      <div className={css.buttonBlock}>
        <Button
          color={Button.COLOR.SECONDARY}
          onClick={onShowClick}
          border={Button.BORDER.BOLD}
          height={Button.HEIGHT.SMALL}
        >
          <TextLocal id={'promoSection.see-all'} />
        </Button>
      </div>
    </div>
  );
};

MultipleSearchUsers.propTypes = {
  onShowClick: PropTypes.func.isRequired,
  data: PropTypes.array,
  currentUserId: PropTypes.string,
  isClinic: PropTypes.bool,
};

export default MultipleSearchUsers;
